import { createSlice } from '@reduxjs/toolkit'

const SpotlightSlice = createSlice({
    name: 'spotlight',
    initialState: {
        targets: [] as any[],
        activeTargetIndex: 0,
        visible: false,
    },
    reducers: {
        setTargets: (state, action) => {
            state.targets = action.payload
            state.activeTargetIndex = 0
        },
        setActiveTargetIndex: (state, action) => {
            state.activeTargetIndex = action.payload
        },
        nextTarget: (state) => {
            if (state.activeTargetIndex < state.targets.length - 1) {
                state.activeTargetIndex += 1
            } else {
                state.activeTargetIndex = 0
                state.visible = false
            }
        },
        prevTarget: (state) => {
            if (state.activeTargetIndex > 0) {
                state.activeTargetIndex -= 1
            }
        },
        setVisible: (state, action) => {
            state.visible = action.payload
        }
    },
})

export const { setTargets, setActiveTargetIndex, setVisible, nextTarget, prevTarget } = SpotlightSlice.actions

export default SpotlightSlice.reducer
